import React, { useState } from "react";
import { Link, Stack, Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { toast } from "react-toastify";
import { openVeersaPointsSubmissionEvidence } from "../../http/requests/veersa-points";

function pick(row, ...keys) {
  if (!row) return "";
  for (const k of keys) {
    const v = row[k];
    if (v != null && String(v).trim()) return String(v).trim();
  }
  return "";
}

/**
 * Uploaded evidence file (via API blob proxy) and optional content link on a submission row.
 */
export default function SubmissionEvidenceLinks({ submission, admin = false, compact = false }) {
  const [loading, setLoading] = useState(false);
  const attachmentUrl = pick(submission, "attachmentUrl", "AttachmentUrl");
  const attachmentFileName = pick(submission, "attachmentFileName", "AttachmentFileName") || "View uploaded file";
  const contentLink = pick(submission, "contentLink", "ContentLink");
  const submissionId = submission?.submissionId ?? submission?.SubmissionId;

  if (!attachmentUrl && !contentLink) {
    return compact ? (
      <Typography component="span" variant="body2" color="text.secondary">
        —
      </Typography>
    ) : (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  const openFile = async (e) => {
    e.preventDefault();
    if (!submissionId || loading) return;
    setLoading(true);
    try {
      await openVeersaPointsSubmissionEvidence(submissionId, { admin });
    } catch {
      toast.error("Could not open the uploaded file.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack direction="column" spacing={0.5} alignItems="flex-start" sx={{ maxWidth: compact ? 180 : "100%" }}>
      {attachmentUrl && submissionId ? (
        <Link
          component="button"
          type="button"
          variant="body2"
          onClick={openFile}
          disabled={loading}
          sx={{ textAlign: "left", wordBreak: "break-word" }}
        >
          <AttachFileIcon sx={{ fontSize: 16, verticalAlign: "middle", mr: 0.5 }} />
          {loading ? "Opening…" : attachmentFileName}
        </Link>
      ) : null}
      {contentLink ? (
        <Link href={contentLink} target="_blank" rel="noopener noreferrer" variant="body2" sx={{ wordBreak: "break-all" }}>
          <OpenInNewIcon sx={{ fontSize: 16, verticalAlign: "middle", mr: 0.5 }} />
          {compact ? "Content link" : contentLink}
        </Link>
      ) : null}
    </Stack>
  );
}
